import { simplePath } from "../../utils.js";
import joi from "joi";
const POST_EMAIL_DEFAULT = 'v2/user-profile-settings/set-default-email';
function post_default_email_path() {
    return simplePath(POST_EMAIL_DEFAULT, {});
}
const schema = joi.object({
    email: joi.string().email({
        tlds: false
    }).required()
}).required();
export { POST_EMAIL_DEFAULT, post_default_email_path, schema };
